module.exports = __webpack_public_path__ + "static/sports-broadcast-students-prepare-for-prime-time-ee05546b62de4b50fada9d6c2fdd95c8.jpg";